//Here for Native
const NativeImage = {
    JFC : require("../../Picture/JFC.png"),
    Pharahos : require("../../Picture/Pharahos.png"),
    RoyleHotel : require("../../Picture/RoyleHotel.png"),
    Shopping : require("../../Picture/Shopping.png"),
    ShopRoom : require("../../Picture/ShopRoom.png"),
    CellOn : require("../../Picture/CellOn.png"),
}
export default NativeImage

